module.exports = __webpack_public_path__ + "static/media/info-keypoint2.219b43d7.png";